$(window).load(function(){
  $("body.wowmall-page-preloader").addClass("preloaded");
})
$(document).ready(function(){
  $("#showLeftPush").click(function(){
    $("body").toggleClass("blocking");
    $("#NavMobile").toggleClass("mobile-menu-open");
    $("#c-mask").toggleClass("is-active");
  });
  $(".c-menu__close, .c-mask").click(function(){
    $("body").toggleClass("blocking");
    $("#NavMobile").toggleClass("mobile-menu-open");
    $("#c-mask").toggleClass("is-active");
  });
  
 if($(window).width() < 768){
// var stickyNav = function(){
// var scrollTop = $(window).scrollTop();    
// if (scrollTop > 10) { 
//     $('.header-middle').addClass('fixedbarm');
// } else {
//     $('.header-middle').removeClass('fixedbarm'); 
// }
// };
// stickyNav();
// $(window).scroll(function() {
//   stickyNav();
// });
  
}else{
var stickyNavTop = $('.nav-bar').offset().top;
var stickyNav = function(){
var scrollTop = $(window).scrollTop();    
if (scrollTop > stickyNavTop) { 
    $('#header').addClass('fixedbar');
    $('.header_top').hide();
    $('.header-middle').addClass('fixheader-mid');
    $('.header-bottom').addClass('navfix');
} else {
    $('#header').removeClass('fixedbar'); 
    $('.header_top').show();
    $('.header-middle').removeClass('fixheader-mid');
    $('.header-bottom').removeClass('navfix');
}
};
stickyNav();
$(window).scroll(function() {
  stickyNav();
});
}
$( window ).scroll(function() {
  var scroll = $(window).scrollTop();
  if($(window).width() > 767){
    if(scroll >= 215){
      if(!$('.cart__footer-icon').hasClass('in')){
        $('.cart__footer-icon').addClass('in');
      }
    } else {
      $('.cart__footer-icon').removeClass('in');
    }
  } else {
    if(scroll >= 90){
      if(!$('.cart__footer-icon').hasClass('in')){
        $('.cart__footer-icon').addClass('in');
      }
    } else {
      $('.cart__footer-icon').removeClass('in');
    } 
  }
});
window.onload = function() {
 jQuery(function($) {
   var offset = 300;
   var duration = 500;
   $(document).scroll(function() {
 
     if ($(this).scrollTop() > offset) {
       $('.back-to-top').fadeIn(duration);
     } 
     else {
       $('.back-to-top').fadeOut(duration);
     }
   });
   $('.back-to-top').unbind('click.smoothscroll').bind('click', function(e) {
     e.preventDefault();
     $('html, body').animate( { scrollTop: 0 }, duration);
     return false;
   })
 });
} 
//Menu
var timerVar;
$("nav").each(function(){
  if(!$( this ).hasClass("navbar-vertical")) {
    $( this ).find(".dropdown").each(function(){
      $( this ).hover(
        function() {
          var $this = $( this );
          var $obj = $this.find(".dropdown-menu");
          if($obj.length) {
            $obj.fadeOut(0);
            timerVar = setTimeout(function(){ 
              $this.addClass("active"); 
              $obj.fadeIn(200);
              submenuXposition($obj);
              submenuYposition($obj);
              $( window ).bind( "scroll", { obj: $obj }, menuScroll);
            }, 300);
          }
        }, function() {
          var $this = $( this );
          var $obj = $this.find(".dropdown-menu");
          clearTimeout(timerVar);
          $( window ).unbind( "scroll", menuScroll);
          if($this.hasClass("active")){
            $obj.fadeOut(300);
            setTimeout(removeActiveItem, 300, $this);
          }
        }
      );
    });
  }
});
function submenuXposition($obj){
	var w_width = window.innerWidth;
	var o_position = $obj.offset().left;
	var o_width = $obj.outerWidth();
	var delta = parseInt(w_width - o_position - o_width - 25);
	
	if(delta < 0) {
		$obj.css("left", delta);
	}
}
function submenuYposition($obj){
	var w_height = window.innerHeight;
	var o_position = $(".desktop_nav").hasClass("fixedbar") ? $obj.position().top : $obj.offset().top;
	var o_height = $obj.outerHeight();
	var delta = parseInt(w_height - o_position - o_height);
	if(delta < 0) {
		$obj.css({"max-height": o_height + delta - 25, "overflow": "auto"});
	}
}
function menuScroll(event) {
	event.data.obj.removeAttr("style");
	submenuXposition(event.data.obj);
	submenuYposition(event.data.obj)
}

function removeActiveItem(item){
  item.removeClass("active");
  item.removeAttr("style");
} 
  
 $('.js-qty__adjust').on('click', function() {
      var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
        
      } else {
        qty = 1;
      }

      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 1) qty = 1;
      }

      $qtySelector.val(qty);
    });
  
});
$(function() {
	FastClick.attach(document.body);
});
// Search auto complete
var w = window.innerWidth;
if( w > 414)
{
$(function() {
      // Current Ajax request.
      var currentAjaxRequest = null;
      // Grabbing all search forms on the page, and adding a .search-results list to each.
      var searchForms = $('form[action="/search"]').css('position','relative').each(function() {
        // Grabbing text input.
        var input = $(this).find('input[name="q"]');
        // Adding a list for showing search results.
        var offSet = input.position().top + input.innerHeight();
        $('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': offSet } ).appendTo($(this)).hide();    
        // Listening to keyup and change on the text field within these search forms.
        input.attr('autocomplete', 'off').bind('keyup change', function() {
          // What's the search term?
          var term = $(this).val();
          // What's the search form?
          var form = $(this).closest('form');
          // What's the search URL?
          var searchURL = '/search?type=product&q=' + term;
          // What's the search results list?
          var resultsList = form.find('.search-results');
          // If that's a new term and it contains at least 3 characters.
          if (term.length > 3 && term != $(this).attr('data-old-term')) {
            // Saving old query.
            $(this).attr('data-old-term', term);
            // Killing any Ajax request that's currently being processed.
            if (currentAjaxRequest != null) currentAjaxRequest.abort();
            // Pulling results.
            currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
              // Reset results.
              resultsList.empty();
              // If we have no results.
              if(data.results_count == 0) {
                // resultsList.html('<li><span class="title">No results.</span></li>');
                // resultsList.fadeIn(200);
                resultsList.hide();
              } else {
                // If we have results.
                $.each(data.results, function(index, item) {
                  var link = $('<a></a>').attr('href', item.url);
                  link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                  link.append('<span class="title">' + item.title + '</span>');
                  link.wrap('<li></li>');
                  resultsList.append(link.parent());
                });
                // The Ajax request will return at the most 10 results.
                // If there are more than 10, let's link to the search results page.
                if(data.results_count > 10) {
                  resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
                }
                resultsList.fadeIn(200);
              }        
            });
          }
        });
      });
      // Clicking outside makes the results disappear.
      $('body').bind('click', function(){
        $('.search-results').hide();
      });
    });
}
new LazyLoad();